<template >
    <div class="container" v-if="lesson!=null && topic!=null && content!=null">

      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <div class="row">
            
            <h3 class="m-0 font-weight-bold text-primary">Шалгалтын статистик  </h3>
          </div>
        </div>
        <div class="card-body">
          <p><span class="font-weight-bold">Хичээл:</span> {{lesson.name}}</p>
          <p><span class="font-weight-bold">Сэдэв:</span>  {{topic.name}}</p>
          <p><span class="font-weight-bold">Тест:</span>  {{content.name}}</p>

          <hr/>

          <div class="card">
            <div class="card-body">
              <div class="row justify-content-center">
                <div class="">
                  <div v-if="answered && general">
                    <div v-if="rounds!=null && rounds.length>0">
                      <div v-for="(round, index) in rounds" v-bind:key="round.id">
                        <p><span class="font-weight-bold">Огноо:</span> {{round.createdAt | formatDate}}</p>
                        <p>
                          <span  class="text-success">
                            Зөв хариулт: 
                            <span v-if="round.answeredCorrect!=null && round.answeredCorrect!=undefined">{{round.answeredCorrect}}</span>
                            <span v-else>0</span>
                          </span>
                          <span  class="text-danger ml-4">
                            Буруу хариулт: 
                            <span v-if="round.answeredIncorrect!=null && round.answeredIncorrect!=undefined">{{round.answeredIncorrect}}</span>
                            <span v-else>0</span>
                          </span>
                        </p>
                
                        <div style="height:250px;width:250px;">
                          <pie-chart  v-if="round!=null && round.chartData!=null" :chartData="round.chartData" :options="chartOptions"></pie-chart>
                        </div>
                        <hr/>
                      </div>
                    </div>
                  </div>
                  <div v-else class="alert alert-primary">Одоогоор та асуултанд хариулаагүй байна.</div>
                </div>
              </div>

              
            </div>
          </div>
            
        </div>

      </div>



    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import PieChart from "../PieChart.js";

export default {
    name: "TestStudent",
    components: {
      PieChart
    },
    data() {
        return {
          lesson:null,
          topic:null,
          content:null,
          answered:false,
          general:null,
          rounds:[],
          categories: [],

          chartOptions: {
            responsive: false, 
            maintainAspectRatio: false,
            pieceLabel: {
              mode: 'percentage',
              precision: 1
            }
          },
        };
    },
    methods: {  
      getData(){
        if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
          fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).get().then(stdDoc=> {
            if(stdDoc.exists && stdDoc.data().enabled==true){
              fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
                  let lesson=doc.data()
                  lesson.id=doc.id
                  this.lesson=lesson;
              });
              fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).get().then(doc=> {
                  let topic=doc.data()
                  topic.id=doc.id
                  this.topic=topic;
              });
              fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId+"/details/"+this.contentId).get().then(doc=> {
                  let content=doc.data()
                  content.id=doc.id
                  this.content=content;
                    this._findCategories();
                    this.getUserAnswers(doc);
                  
                  
              });
            }
          });
            
            
        }
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      async _getQuestionsOfCategory(cat, catRef){
        var querySnapshot=await catRef
          .collection("questions").orderBy("createdAt","asc").get()
            cat.questions=[];
            for(const doc of querySnapshot.docs){
              let question=doc.data();
                question.id=doc.id;
                question.subquestions=[];

                var subDocs= await doc.ref.collection("subquestions").get();
                for(const subquestion of subDocs.docs){
                  let object=subquestion.data();
                  object.id = subquestion.id;
                  object.answers=[];

                  if(object.answertype==true){
                    // object.useranswers=[]
                    // this._getQuestionAnswers(object, subquestion.ref);
                  }
                  else{
                    object.answers = [];
                    await this._getAnswers(object, subquestion.ref);
                  }

                  question.subquestions.push(object);
                }

                cat.questions.push(question);
           
            }


      },
      async _findCategories(){
        var querySnapshot= await fb.db.collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.contentId+"/tests").orderBy("createdAt","asc").get();
        this.categories = [];
        for(const doc of querySnapshot.docs){
          let cat = doc.data();
          cat.id = doc.id;
          cat.questions=[]
          await this._getQuestionsOfCategory(cat, doc.ref)
          this.categories.push(cat);
        }

        

      },
      async _getAnswers(question, ref) {
        if (question.answers == null || question.answers == undefined)
          question.answers = [];
        var querySnapshot=await ref
          .collection("answers")
          .get();
            question.answers = [];
            let index = 0;
            querySnapshot.docs.forEach(doc => {
              let answer = doc.data();
              answer.id = doc.id;

              question.answers.push(answer);
              index++;
            });
        
   
      },
      getUserAnswers(content){
        content.ref.collection("users").doc(this.currentUser.uid).get().then(userAnswerDoc=>{
          if(userAnswerDoc.exists){
            this.answered=true;
            this.general=userAnswerDoc.data();
            userAnswerDoc.ref.collection('rounds').orderBy('createdAt', "desc").get().then(roundsData=>{
              this.rounds=[];
              if(!roundsData.empty){
                roundsData.forEach(value=>{
                  let round=value.data();
                  round.id=value.id;
                  var chartData= {
                    labels: ["Зөв", "Буруу"],
                    datasets: [
                      {
                        label: "Статистик",
                        backgroundColor: ["#41B883", "#E46651"],
                        data: [
                          round.answeredCorrect!=null && round.answeredCorrect!=undefined?round.answeredCorrect:0,
                          round.answeredIncorrect!=null && round.answeredIncorrect!=undefined?round.answeredIncorrect:0
                        ]
                      }
                    ]
                  }
                  round.chartData=chartData;
                  this.rounds.push(round);
                });
              }
            });
          }
          
          else
            this.answered=false;
        });
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId:{
          required:true
        },
        contentId:{
          required:true
        }
    },
    created() {
      if(this.lessonId!=null && this.lessonId!='' && this.topicId!=null && this.topicId!='' && this.contentId!=null && this.contentId!='')
        this.getData();
          
    },
    filters: {
        formatDateFromNow(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).fromNow()
        },
        formatDate(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).format('MM/DD/YYYY HH:mm');
        },
        trimLength(val) {
            if (val.length < 200) { return val }
            return `${val.substring(0, 200)}...`
        }
    }
  
};
</script>

